<template>
  <el-cascader v-model="selectValue" ref="cascader" :props="props" @change="onChange" :disabled="disabled" :placeholder="placeholder" />
</template>

<script>

export default {
  name: "DyProvinceCascader",
  props: {
    value: {
      type: [Array, String, Object],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "请选择省/市/区/街道",
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selectValue: [],
      props: {
        lazy: true,
        lazyLoad: async (node, resolve) => {
          let {data, level} = node;
          const res = await this.getDistricts(data?.adcode);
          resolve(
              res.map((item) => ({...item, leaf: level > 2, level: level + 1,}))
          );
        },
        value: "name",
        label: "name",
      },
    };
  },
  mounted() {
  },
  methods: {
    onChange() {
      let res = this.$refs.cascader.getCheckedNodes()
      if (res.length === 0) return
      this.$emit("onChange", res[0].pathLabels)
      this.$emit("input", res[0].pathLabels)
    },
    async getDistricts(keywords = "中国", subdistrict = 1, extensions = "base") {
      return new Promise(resolve => {
        // key 高德webapi
        const url = `https://restapi.amap.com/v3/config/district?key=24b266038f6e9ea9578d53e6fdf6e2d9&keywords=${keywords}&subdistrict=${subdistrict}&extensions=${extensions}`;
        // const result = await get(url);
        // return result.data.districts[0];
        fetch(url, {method: 'get'}).then(async (res) => {
          let result = await res.json()
          resolve(result.districts[0].districts);
        })
      })
    }
  },
};
</script>
